import {useEffect, useState} from 'react';

import {Language} from 'constants/language';
import {LanguageService} from 'services';

export function useLanguage(): [Language, (language: Language) => void] {
    const [language, setLanguage] = useState<Language>(LanguageService.getLanguage());
    useEffect(() => LanguageService.subscribeLanguageChange(setLanguage), []);
    return [language, LanguageService.setLanguage];
}